import { useActivation } from '@/hooks/view-model-hooks'
import { observer } from 'mobx-react-lite'
import { type ProDetailsViewModel } from './ProDetailsViewModel'
import { ProDetails } from '@/features/iam/providers/ProDetails'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'

export interface ProDetailsContainerProps {
  vm: ProDetailsViewModel
  showActions?: boolean
}

export const ProDetailsContainer = observer(function ProDetailsContainer({
  vm,
  showActions,
}: ProDetailsContainerProps) {
  useActivation(vm)
  return vm.fetch.match({
    pending: () => <ContentLoading />,
    rejected: (err) => <ContentError error={err} />,
    resolved: () => (
      <ProDetails
        softwareOwned={vm.softwareOwned.slice()}
        onSoftwareOwnedChange={vm.setSoftwareOwned}
        softwareExperience={vm.softwareExperience.slice()}
        onSoftwareExperienceChange={vm.setSoftwareExperience}
        supplementalSoftware={vm.supplementalSoftware.slice()}
        onSupplementalSoftwareChange={vm.setSupplementalSoftware}
        specialties={vm.specialties.slice()}
        onSpecialtiesChange={vm.setSpecialties}
        stateRegion={vm.stateRegion}
        onStateRegionChange={vm.setStateRegion}
        yearsExperience={vm.yearsExperience}
        onYearsExperienceChange={vm.setYearsExperience}
        yearsExperienceError={vm.validation.getError('yearsExperience')}
        editable={vm.editable}
        showActions={showActions}
        onSubmit={vm.save}
        isSavePending={vm.save.pending}
        canSave={vm.canSave}
      />
    ),
  })
})
